//app menu options
//make sure to add help button and logout (if applicable) in the component where this is imported - help button requires an <a> tag for the download
export const menuItems = [
    {
        label: "Job Control",
        icon: "fa-solid fa-clipboard-check",
        path: "/job-control",
        permission: { resource: "jobs", action: "update" },
    },
    {
        label: "Live Track",
        icon: "fa-solid fa-stopwatch",
        path: "/live-track",
        permission: { resource: "livetracks", action: "read" },
    },
    {
        label: "Live Track (edit)",
        icon: "fa-regular fa-pen-to-square",
        path: "/live-track-edit",
        permission: { resource: "livetracks", action: "update" },
    },
    {
        label: "Points of Interest",
        icon: "fa-solid fa-flag",
        path: "/poi-edit",
    },
    {
        label: "Site Map",
        icon: "fa-regular fa-map",
        path: "/site-map",
        permission: { resource: "sitemaps", action: "read" },
    },
    {
        label: "Site Map (w/ PIG)",
        icon: "fa-solid fa-map-location-dot",
        path: "/site-map-pig",
        permission: { resource: "sitemaps", action: "read" },
    },
    {
        label: "Speed Approvals",
        icon: "fa-solid fa-gauge-simple-high",
        path: "/speed-approvals",
        groups: ["Admin", "Supervisor", "Project Manager", "Tracker"],
    },
    {
        label: "Admin Dashboard",
        icon: "fa-solid fa-lock",
        path: "/admin-dashboard",
        groups: ["Admin"],
    },
    {
        label: "Change Password",
        icon: "fa-solid fa-key",
        path: "/change-password",
    },
  ];
  